import React from "react";
import { getImage } from "../TestimonialGetImage/TestimonialGetImage";

const TestimonialItem = ({ val, styles }) => (
    <div className="testimonial-item" style={styles.testimonialContentStyle}>
        <div className="testimonialitem-img-parent">
            <img
                src={getImage(val)}
                alt="Testimonial Image"
            />
        </div>
        <div className="testimonialitem-content">
            <b className="testimonialitem-name" style={styles.testimonialNameStyle}>
                {val?.name || ""}
            </b>
            <p className="testimonialitem-desc" style={styles.testimonialDescriptionStyle}>
                {val?.description || ""}
            </p>
        </div>
    </div>
);

export default TestimonialItem;
